export enum SearchResultType {
  Guest = 'guest',
  Invoice = 'invoice',
  Booking = 'inquiry',
  Hold = 'calendar',
  Hold2 = 'hold_event',
  Rental = 'rental',
}
